/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_StatusInputs */



/**
* | output |
* | --- |
* | "Subscription Status" |
*
* @param {Subscription_StatusInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subscription_status = /** @type {((inputs?: Subscription_StatusInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_StatusInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Statut d’abonnement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Abonnementstatus")
	if (locale === "it") return /** @type {LocalizedString} */ ("Stato dell'abbonamento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Статус подписки")
	if (locale === "es") return /** @type {LocalizedString} */ ("Estado de suscripción")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("订阅状态")
	if (locale === "ja") return /** @type {LocalizedString} */ ("サブスクリプションステータス")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सदस्यता स्थिति")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Status da assinatura")
	return /** @type {LocalizedString} */ ("Subscription Status")
});